import { useRef, useState } from "react";
import {
  FaCloudUploadAlt, FaCamera, FaSearch, FaTimes,
  FaPaw, FaMapMarkerAlt, FaVenus, FaMars
} from "react-icons/fa";
import { MdPets } from "react-icons/md";
import { ORASE, RASE_CAINE, RASE_PISICA, CULORI } from "../data/optiuniAnunt";
import "./FiltreSearch.css";
import logo from "../assests/logo.png"

export default function FiltreSearch({ onCauta, tip = "gasit" }) {
  const [imagine, setImagine] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filtre, setFiltre] = useState({
    specie: "", rasa: "", sex: "", culoare: "", oras: "",
  });

  const fileRef = useRef();
  const cameraRef = useRef();

const handleFile = async (file) => {
  if (!file) return;
  setImagine(file);
  setPreview(URL.createObjectURL(file));
  
  // Caută automat după upload — fără să apese buton
  await cautaDupaImagine(file);
};

const cautaDupaImagine = async (file) => {
  if (!process.env.REACT_APP_AI_SERVICE_URL) return;
  setLoading(true);

  console.log("Tip trimis la AI:", tip); // ← debug

  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tip", tip);

    console.log("FormData tip:", formData.get("tip")); // ← debug

    const res = await fetch(
      `${process.env.REACT_APP_AI_SERVICE_URL}/search`,
      { method: "POST", body: formData }
    );
    const data = await res.json();

    console.log("AI rezultate:", data.ids, "scoruri:", data.scores); // ← debug

    if (onCauta) {
      await onCauta({
        filtre,
        imagine: file,
        rezultateAI: data.ids,
        scoruri: data.scores
      });
    }
  } catch (err) {
    console.log("AI offline:", err.message);
  } finally {
    setLoading(false);
  }
};

  const handleFiltru = (e) => {
    const { name, value } = e.target;
    setFiltre((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "specie" ? { rasa: "" } : {}),
    }));
  };

  const handleReset = () => {
    setImagine(null);
    setPreview(null);
    setFiltre({ specie: "", rasa: "", sex: "", culoare: "", oras: "" });
    if (fileRef.current) fileRef.current.value = "";
    if (onCauta) onCauta({ filtre: {}, imagine: null, reset: true });
  };

  const handleCauta = async () => {
  setLoading(true);

  let rezultateAI = null;

  // Dacă există imagine → trimite la AI service
  if (imagine && process.env.REACT_APP_AI_SERVICE_URL) {
    try {
      const formData = new FormData();
      formData.append("file", imagine);
      formData.append("tip", tip);

      const res = await fetch(
        `${process.env.REACT_APP_AI_SERVICE_URL}/search`,
        { method: "POST", body: formData }
      );
      const data = await res.json();
      rezultateAI = data.ids; // array de anunt_id
      console.log("AI rezultate:", data.ids, "scoruri:", data.scores);
    } catch (err) {
      console.log("AI service offline:", err.message);
    }
  }

  // Trimite filtrele + rezultatele AI către pagina părinte
  if (onCauta) await onCauta({ filtre, imagine, rezultateAI });
  setLoading(false);
};

  const rase = filtre.specie === "caine" ? RASE_CAINE : RASE_PISICA;

  return (
    <section className="filtre-search">

      {/* Hero */}
      <div className="filtre-hero">
        {/* <img style={{ width: '120px' }} src={logo} alt="" /> */}
        {/* <h1 className="filtre-hero-title">FindMyPet</h1> */}
        <p className="filtre-hero-subtitle">
          Încarcă o poză cu animalul {tip === "gasit" ? "găsit" : "pierdut"} +
          folosește filtrele pentru căutare avansată.
        </p>
      </div>

      {/* Butoane imagine */}
      <div className="filtre-imagine-butoane">
        <label className="imagine-card" htmlFor={`upload-${tip}`}>
          <input
            id={`upload-${tip}`}
            ref={fileRef}
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => handleFile(e.target.files[0])}
          />
          <FaCloudUploadAlt className="imagine-icon" />
          <span>Încarcă Poză</span>
        </label>

        <label className="imagine-card" htmlFor={`camera-${tip}`}>
          <input
            id={`camera-${tip}`}
            ref={cameraRef}
            type="file"
            accept="image/*"
            capture="environment"
            hidden
            onChange={(e) => handleFile(e.target.files[0])}
          />
          <FaCamera className="imagine-icon" />
          <span>Fă o Poză</span>
        </label>
      </div>

      {/* Divider */}
      <div className="filtre-divider">
        <span>SAU CAUTĂ DUPĂ DETALII</span>
      </div>

      {/* Secțiunea avansată — imagine preview + filtre împreună */}
      <div className="filtre-avansate">
        <h3><FaSearch /> Căutare Avansată</h3>

        <div className="filtre-body">

          {/* Preview imagine — apare în stânga filtrelor */}
          {preview && (
  <div className="filtre-preview">
    <div className="preview-wrapper">
      <img src={preview} alt="animal" className="preview-img" />
      <button
        className="btn-remove-preview"
        onClick={() => { setImagine(null); setPreview(null); }}
      >
        <FaTimes />
      </button>
    </div>
    <p className="preview-label">
      {loading
        ? <><FaSearch /> Se caută animale similare...</>
        : <><FaPaw /> Imagine selectată</>
      }
    </p>
  </div>
)}

          {/* Grid filtre */}
          <div className="filtre-grid">

            <div className="filter-group">
              <label><FaPaw /> Specie</label>
              <select name="specie" value={filtre.specie} onChange={handleFiltru}>
                <option value="">Toate speciile</option>
                <option value="caine"> Câine</option>
                <option value="pisica"> Pisică</option>
              </select>
            </div>

            {filtre.specie && (
              <div className="filter-group">
                <label>Rasă</label>
                <select name="rasa" value={filtre.rasa} onChange={handleFiltru}>
                  <option value="">Toate rasele</option>
                  {rase.map((r) => (
                    <option key={r} value={r}>{r}</option>
                  ))}
                </select>
              </div>
            )}

            <div className="filter-group">
              <label>Sex</label>
              <select name="sex" value={filtre.sex} onChange={handleFiltru}>
                <option value="">Orice sex</option>
                <option value="mascul">♂ Mascul</option>
                <option value="femela">♀ Femelă</option>
              </select>
            </div>

            <div className="filter-group">
              <label>Culoare</label>
              <select name="culoare" value={filtre.culoare} onChange={handleFiltru}>
                <option value="">Orice culoare</option>
                {CULORI.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label><FaMapMarkerAlt /> Oraș</label>
              <select name="oras" value={filtre.oras} onChange={handleFiltru}>
                <option value="">Toate orașele</option>
                {ORASE.map((o) => (
                  <option key={o} value={o}>{o}</option>
                ))}
              </select>
            </div>

          </div>
        </div>

        {/* Butoane acțiune */}
        <div className="filtre-actiuni">
          <button
            className="btn-cauta"
            onClick={handleCauta}
            disabled={loading}
          >
            <FaSearch />
            {loading ? "Se caută..." : "Caută Acum"}
          </button>
          <button className="btn-reset" onClick={handleReset}>
            <FaTimes /> Resetează
          </button>
        </div>

      </div>
    </section>
  );
}